import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(relativeTime);

export const getDiffTime = (value: string) => dayjs(value).fromNow().replace("a few seconds ago", "Now");

export const checkTimeRange = (time: string, range: number) => {
  const now = new Date();
  return dayjs(now).diff(dayjs(time), "minutes") <= range;
};

/**
 * Change HH:mm:ss to dayjs format
 * @param time HH:mm:ss format
 */
export const changeTimeFormatIntoDayjsFormat = (time: string) => {
  if (!time) return "";

  const timeStr = time.split(":");
  if (!timeStr || timeStr.length < 1) return "";

  const hour = Number(timeStr[0]);
  const minute = Number(timeStr[1]);
  const second = Number(timeStr[2]);
  return dayjs().set("hours", hour).set("minutes", minute).set("second", second).set("millisecond", 0);
};

export const checkTimeWithCurrentTime = (time: string) => {
  if (!time) return null;
  return checkTimeRange(changeTimeFormatIntoDayjsFormat(time) as string, 0);
};

export { dayjs };
